// dashboard-view.js

import Immutable from 'immutable';
import moment from 'moment';

import {Model, View} from 'backbone';

import constants from 'Constants.js';
import contentTemplate from 'dashboard/dashboard-view.ejs';
import listService from 'ListService.js';
import NotificationService from 'NotificationService.js';

import NotificationLeftPanel    from 'dashboard/notifications/NotificationsLeftPanelView.js'
import NotificationsDetailView  from 'dashboard/notifications/NotificationsDetailView.js'


import FormLeftPanel  from 'dashboard/forms/FormLeftPanelView.js';
import AppWorkspaceView from 'dashboard/forms/AppWorkspaceView.js';


import ReportLeftPanelView  from 'dashboard/reports/ReportLeftPanelView.js';
import ReportDetailsModel   from 'ReportDetailsModel.js';
import ReportsDetailView from 'dashboard/reports/ReportDetailsView.js'
import ReportWorkspaceView from 'dashboard/reports/ReportWorkspaceView.js';

import SettingsLeftPanel         from 'dashboard/settings/SettingsLeftPanelView.js'
import SettingsMainView       from 'dashboard/settings/SettingsMainView.js'

import ConnectionsLeftPanelView         from 'dashboard/connections/ConnectionsLeftPanelView.js'
import ConnectionsDashboardView         from 'dashboard/connections/ConnectionsDashboardView.js'

import RestService from 'RestService';
import restMessages from 'RestMessages';
import undoService from 'UndoService';
import userService from 'UserService';
import eventBus  from 'EventBus.js';
import util from 'util/Util';
import FormDetailsModel from "../../models/FormDetailsModel";
import ConnectionDetailsModel from "../../models/ConnectionDetailsModel";
import ActionDetailsModel from "../../models/ActionDetailsModel";
import UserDetailsModel from "../../models/UserDetailsModel";
import AccountSettingsModel from "../../models/AccountSettingsModel";
import ListDetailsModel from "../../models/ListDetailsModel";
import UserPositionDetailsModel from "../../models/UserPositionDetailsModel";
import SynchronizationProfileModel from "../../models/SynchronizationProfileModel";
import EmailServerDetailsModel from "../../models/EmailServerDetailsModel";
import PersonalDetailsModel from "../../models/PersonalDetailsModel";
import PopupWrapperService from 'PopupWrapperService';

import quickHelp from '../QuickHelpView';

const SILENT = constants.MODEL_SILENT;

//============================================================================
// This is the main view of the PF Designer dashboard, a tabbed panel.
// It dispatches each tab as a replaced subview.
// - Lou Mauget, February 24, 2016
//============================================================================
class DashboardView extends View {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.tagName = 'div';
        this.id = '#content';
        this.panelOne = '#dbPanelOne';
        this.panelTwo = '#dbPanelTwo';


        // A click triggers a tab subview, navigation to help route, or navigation to exit route.
        this.events = {
            'click .dashboard-tab': 'tabSelected',
            'click  #menuHelp': '_menuHelp',
            'click  #menuExit': '_menuExit',
            'click #dashboardUndo': 'undoAction',
            'click #dashboardRedo': 'redoAction',
            'click #pf-refresh-main-view' : 'refreshMainView',
            'click .pf-upgrade-urgent, .pf-upgrade-normal' : 'upgrade', 
            'click #nav-menu-desktop li a': 'navigateAround'
        };

        // Define the tabs panels. To implement a tab, add ES6 class declarations for
        // panel1Class and panel2Class to its object. (Uppercase Map is a hash)

        // Update Rene Lopez Sept 2016
        // Needs Refactoring here as the starting views will require for API Calls
        // As an example the View Reports can be taken as a basis.
        this.options.tabs = Immutable.Map(
            {
                'forms': {
                    leftPanel: FormLeftPanel,
                    mainPanel: AppWorkspaceView
                },
                'reports': {
                    leftPanel: ReportLeftPanelView,
                    mainPanel: ReportWorkspaceView
                },
                'notifications': {
                    leftPanel: NotificationLeftPanel,
                    mainPanel: NotificationsDetailView
                },
                'connections': {
                    leftPanel: ConnectionsLeftPanelView,
                    mainPanel: ConnectionsDashboardView
                },
                'settings': {
                    leftPanel: SettingsLeftPanel,
                    mainPanel: SettingsMainView
                }
            });

        const tabName=listService._activeDashboardTab ? listService._activeDashboardTab : 'forms';

        this.setHelpUrl(tabName);

        if(!this.model.has('selectedTab')){
            this.model.set('selectedTab', tabName, SILENT);
        }

        this.model.set('pf_version', constants.PF_VERSION, SILENT);
        this.model.set('app_url', constants.APP_URL, SILENT);
        this.model.set('app_logo', constants.APP_LOGO, SILENT);

        const hasPermissions = util.isTrue(userService.checkPermissions('connections'));
        this.model.set('hasPermissions', hasPermissions, SILENT);

        this.listenTo(eventBus, 'loadFormsView', ()=>{this.loadTab('forms')});
        this.listenTo(eventBus, 'loadReportsView', ()=>{this.loadTab('reports')});
        this.listenTo(eventBus, 'loadConnectionsView', ()=>{this.loadTab('connections')}); 
        this.listenTo(eventBus, 'loadSettingsView', ()=>{this.loadTab('settings')}); 
        this.listenTo(eventBus, 'loadNotificationsView', ()=>{this.loadTab('notifications')});

        return this;
    }

    navigateAround (e) {
        let target = e.target.className;

        if (target) {
            switch (target) {
                case 'pf-home':
                    e.preventDefault();
                    this.takeMeBackHome();
                  break;
            }
        }
    }

    takeMeBackHome () {
        this.loadTab(listService.activeDashboardTab);
    }

    undoAction(e) {
        e.preventDefault();
        if (undoService.hasUndo()) {
            undoService.undo();
        }
    }

    redoAction(e) {
        e.preventDefault();
        if(undoService.hasRedo()) {
            undoService.redo();
        }
    }
    
    stopThis(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    tabSelected(ev) {
        ev.preventDefault();

        //PF-5994 Do not load the next tab until the last one completed loading
        if (listService.dashboardMenuClick) {
            return;
        }

            listService.dashboardMenuClick = true;

            let activeSection = listService.activeDashboardTab, subtitle, applyChangesElement;

            switch (activeSection) {
                case "forms": applyChangesElement = $('#applyChangesForm'); break;
                case "reports": applyChangesElement = $('#applyChangesReport'); break;
                case "connections": applyChangesElement = $('input[name="applyChanges"]'); break;
                case "settings": applyChangesElement = $('input[name="applyChanges"]'); break;
                default: applyChangesElement = $('#applyChangesForm'); break;
            }

            subtitle = this.getSubtitleForTabs();
            if (subtitle) {

                const confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.';

                util.showConfirmationDashboardChangesModal(applyChangesElement, this.processSelectedTab, confirmationText, subtitle, ev, this);
            }
            else {
                this.processSelectedTab(ev)
            }
        
    }

    processSelectedTab(ev){
        ev.preventDefault();
        // load selected content
        const tabName = ev.currentTarget.attributes.name.value;
        this.setHelpUrl(tabName);
        this.loadTab(tabName);
    }

    setHelpUrl(tabName){
        switch(tabName) {
            case 'forms':
                this.model.set('helpUrl', constants.HELP_FORMS_URL, SILENT);
                this.changeURL(constants.HELP_FORMS_URL);
                break;
            case 'reports':
                this.model.set('helpUrl', constants.HELP_REPORTS_URL, SILENT);
                this.changeURL(constants.HELP_REPORTS_URL);
                break;
            case 'notifications':
                this.model.set('helpUrl', constants.HELP_NOTIFICATIONS_URL, SILENT);
                this.changeURL(constants.HELP_NOTIFICATIONS_URL);
                break;
            case 'connections':
                this.model.set('helpUrl', constants.HELP_CONNECTIONS_URL, SILENT);
                this.changeURL(constants.HELP_CONNECTIONS_URL);
                break;
            case 'settings':
                this.model.set('helpUrl', constants.HELP_URL_ACCOUNT_SETTINGS, SILENT);
                this.changeURL(constants.HELP_URL_ACCOUNT_SETTINGS);
                break;
            default:
                this.model.set('helpUrl', constants.HELP_URL, SILENT);
                this.changeURL(constants.HELP_URL);
        }

        // Do not render tab in this method. That would cause a second tab rnnder attempt logging an authentication error.
        //this.loadTab(tabName);

        $('li.dashboard-tab').removeClass('active');
        $(`li[name='${this.model.get('selectedTab')}']`).addClass('active');
    }

    changeURL(newURL){
        let link = document.getElementById("help-URL"); 
        if(link){
            link.setAttribute("href", newURL);
        }

        $("#quick-help-center").off().on("click", () =>{
            window.open(newURL, '_blank');
        });
    }

    checkUpgrade(){

        // Getting the Account Expiration Date from Settings
        const profile=RestService.getProfile();
        const expiryDate=moment(profile.ExpiryDate);
        
        //If there isn't property hide the button
        if(!profile.UpgradeButton){
            $('.pf-upgrade-urgent').hide();
            $('.pf-upgrade-normal').hide();
            return;
        }
        
        // Getting the Upgrade Button Settings from Admin Console
        let upgradeButtonProperties=profile.UpgradeButton.split(',');

        // First string tells the app from which day the upgrade button should appear.
        // Second String tells the app from which day the button should be red and a tooltip must appear
        let daysForDisplayUpgradeButton=upgradeButtonProperties[0];
        let daysForDisplayUrgentUpgradeButton=upgradeButtonProperties[1];
        const today=moment();

        // Making substraction counting the current and last days.
        const daysLeft=expiryDate.diff(today,'days') + 2;

        // Rules for display Upgrade Gray Button
        if(daysLeft <= parseInt(daysForDisplayUpgradeButton)){
            $('.pf-upgrade-urgent').hide();
            $('.pf-upgrade-normal').show();

            // Rules for display Upgrade Red Button and Tooltip
            if(daysForDisplayUrgentUpgradeButton && daysLeft <= parseInt(daysForDisplayUrgentUpgradeButton)){
                $('.pf-upgrade-normal').hide();
                $('.pf-upgrade-urgent').show();
                $('.pf-upgrade-urgent > a').attr('title','You have '+ (daysLeft - 2) +' days left!');
            }
        }

        // Hiding everything if no condition is met.
        else{
            $('.pf-upgrade-normal').hide();
            $('.pf-upgrade-urgent').hide();
        }
    }

    // Method that request the current resource to redirect the user to upgrade its account.
    upgrade(ev){
        ev.preventDefault();
        RestService.getSignUpMethod().then((response)=>{
            const profile=RestService.getProfile();
            let urlToRedirect=`${response.AccountPurchaseURL}?${profile.EmailAddress}&account=${profile.AccountId}`;
            //window.open(urlToRedirect,'_blank');
            PopupWrapperService.windowOpen( urlToRedirect, '_blank') ;
        }).catch((error) => {
            console.log(error);
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    getSubtitleForTabs(){
        if(!listService._dashboardLayout.mainPanelView || !listService._dashboardLayout.mainPanelView.model){
            return '';
        }
        let activeTab=listService._dashboardLayout.mainPanelView.model;

        switch (activeTab.constructor){
            case FormDetailsModel:return `App - ${activeTab.get('formName')}`;
            case ReportDetailsModel:return `Report - ${activeTab.get('reportName')}`;
            case ConnectionDetailsModel:return `Connections - ${activeTab.get('connectionDetails').Name}`;
            case ActionDetailsModel:return`Connections - ${activeTab.get('actionDetails').Name}`;
            case UserDetailsModel:
                if(activeTab.get('groupDetails')) {
                    return `Settings - ${activeTab.get('groupDetails').Name}`;
                }
                    return `Settings - ${activeTab.get('userDetails').FirstName} ${activeTab.get('userDetails').LastName}`;
            case AccountSettingsModel:return `Settings - ${activeTab.get('accountSettings').Name}`;
            case EmailServerDetailsModel:return `Settings - ${activeTab.get('emailServerDetails').Name}`;
            case ListDetailsModel:return `Settings - ${activeTab.get('listDetails').Name}`;
            case UserPositionDetailsModel:return `Settings - ${activeTab.get('userPositionDetails').Name}`;
            case SynchronizationProfileModel:return `Settings - Synchronize Users with Directory Service`;
            case PersonalDetailsModel: return `Settings - ${activeTab.get('personalDetails').FirstName} ${activeTab.get('personalDetails').LastName}`;
            default:return '';
        }
    }

    //=======================================================
    // Populate a tab panel view designated by tabName
    //=======================================================
    _dispatchTabView(views, tabName ) {

        const _this = this;

        // Render the given tab view

        const formsFn = (() => {

            const param = {
                includeRecentManagedForms: 'true',
                includeAllManagedForms: 'true', 
                includeFavoriteForms: 'true'
            };

            RestService.getDashboardDetails(param).then((data => {
                let recentForms = [];
                let formInstances = [];
                let currentFavoritesList = [];
                const allRecentManagedForms = data.RESULT.RESPONSE.allManagedForms;
                const recentManagedForms = data.RESULT.RESPONSE.recentManagedForms;
                const favoriteForms = data.RESULT.RESPONSE.favoriteForms;

                if (allRecentManagedForms && allRecentManagedForms.form) {
                    formInstances = allRecentManagedForms.form instanceof Array
                        ? allRecentManagedForms.form
                        : [allRecentManagedForms.form];
                }

                if (recentManagedForms && recentManagedForms.form) {
                    recentForms = recentManagedForms.form instanceof Array
                        ? recentManagedForms.form
                        : [recentManagedForms.form];
                }

                if (favoriteForms && favoriteForms.form) {
                    currentFavoritesList = favoriteForms.form instanceof Array
                        ? favoriteForms.form
                        : [favoriteForms.form];
                }

                _this.model.set('recentForms', recentForms, SILENT);
                _this.model.set('formInstances', formInstances, SILENT);
                _this.model.set('currentFavoritesList', currentFavoritesList, SILENT);

                // //PF-5501 If a form was closed load the details view page of that form
                // const form = listService.dashboardLayout.mainPanelView;
                // if (form) {
                //     let formId = form.model.get('formId');
                //     let formClosed = form.model.get('closedForm');
                //     if (formId && formClosed) {
                //         eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, formId, constants.FORMS_PRIVATE_GROUP_TYPE, `${constants.FORMS_PRIVATE_GROUP_TYPE}-${formId}`);
                //         form.model.set('closedForm', false, {silent:true});
                //     }
                // }

                listService.dashboardLayout.mainPanelView = new views['mainPanel']({
                    model: _this.model,
                    el: constants.DASHBOARD_MAIN_PANEL
                });
                
                listService.dashboardLayout.mainPanelView.render();
                eventBus.trigger(constants.DASHBOARD_LOADED);

                //PF-5994 until the dashboard was loaded change the flag to allow a new event
                listService.dashboardMenuClick = false;

            }), ( err => {
                console.log(`forms: reject from RestService.getDashboardDetails`, restMessages.codeToMessage(err.CODE || 'unclassified error'));
                console.log(`form tab init was probably called twice for one mouse click`);
            })).catch((err) => {
                restMessages.codeToMessage(err.CODE || '');
            });
        });

        const reportFn = (() => {
            // API Call to /Reports/Dashboard
            const editRequestParamsObject = {
                includeRecentManagedReports: 'true', 
                includeFavoriteReports: 'true'
            };

            RestService.getDashboardDetails(editRequestParamsObject).then((data => {
                let reports = [];
                let currentFavoritesList = [];


                const recentManagedReports = data.RESULT.RESPONSE.recentManagedReports;
                const favoriteReports = data.RESULT.RESPONSE.favoriteReports;

                if (recentManagedReports && recentManagedReports.report) {
                    reports = data.RESULT.RESPONSE.recentManagedReports.report instanceof Array
                        ? data.RESULT.RESPONSE.recentManagedReports.report
                        : [data.RESULT.RESPONSE.recentManagedReports.report];
                }

                if (favoriteReports && favoriteReports.report) {
                    currentFavoritesList = favoriteReports.report instanceof Array
                        ? favoriteReports.report
                        : [favoriteReports.report];
                }


                RestService.getReportsByGroupType(constants.REPORTS_PRIVATE_GROUP_TYPE).then((data)=> {
                    let pReports = [];
                    const privateReports = data.RESULT.RESPONSE.Group;
                    if (privateReports && privateReports.Item) {
                        pReports = data.RESULT.RESPONSE.Group.Item instanceof Array
                            ? data.RESULT.RESPONSE.Group.Item
                            : [data.RESULT.RESPONSE.Group.Item];
                    }
                    // const reportDetailsModel = new ReportDetailsModel();
                    // reportDetailsModel.set('reports', reports);
                    // reportDetailsModel.set('privateReports', pReports);
                    // reportDetailsModel.set('currentFavoritesList', currentFavoritesList, SILENT);

                    // //PF-5501 If a report was closed load the details view of that report
                    // const report = listService.dashboardLayout.mainPanelView;
                    // if (report) {
                    //     let reportId = report.model.get('reportId');
                    //     let reportClosed = report.model.get('closedForm');
                    //     if (reportId && reportClosed) {
                    //         eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId, undefined, undefined, undefined, report.model.get("IsPrivate"));
                    //         report.model.set('closedForm', false, {silent:true});
                    //     }
                    // }

                    listService.dashboardLayout.mainPanelView = new views['mainPanel']({
                        model: _this.model,
                        el: constants.DASHBOARD_MAIN_PANEL
                    });
                    listService.dashboardLayout.mainPanelView.render();
                    eventBus.trigger(constants.DASHBOARD_REPORTS_LOADED);
                    //PF-5994 until the dashboard was loaded change the flag to allow a new event
                    listService.dashboardMenuClick = false;
                });

            }), ( err => {
                console.log(`reports: reject from RestService.getDashboardDetails`, restMessages.codeToMessage(err.CODE || 'unclassified error'));
                console.log(`report tab init was probably called twice for one mouse click`);
            })).catch((err) => {
                console.log("An error has occurred", err);
            });
        });

        const notificationsFn = (() => {
            const requestParamsObject = {
                includeNotifications: 'true',
                notificationsFromAttentionLevel: '1',
                notificationsToAttentionLevel: '5'
            };

            RestService.getDashboardDetails(requestParamsObject).then((data => {
                let notificationList = [];
                const respNotificationList = data.RESULT.RESPONSE.NotificationList;
                if (respNotificationList && respNotificationList.Notification) {
                    notificationList = data.RESULT.RESPONSE.NotificationList.Notification instanceof Array
                        ? data.RESULT.RESPONSE.NotificationList.Notification
                        : [data.RESULT.RESPONSE.NotificationList.Notification];
                }
                _this.model.set('notificationList', notificationList, SILENT);

                listService.dashboardLayout.mainPanelView = new views['mainPanel']({
                    model: _this.model,
                    el: constants.DASHBOARD_MAIN_PANEL
                });
                listService.dashboardLayout.mainPanelView.render();
                //PF-5994 until the dashboard was loaded change the flag to allow a new event
                listService.dashboardMenuClick = false;

            }), ( err => {
                console.log(`notifications: reject from RestService.getDashboardDetails`, restMessages.codeToMessage(err.CODE || 'unclassified error'));
                console.log(`notifications tab init was proobably called twice for one mouse click`);
            })).catch((err) => {
                console.log("An error has occurred", err);
            });
        });

        const connectionsFn = (() => {
            listService.dashboardLayout.mainPanelView = new views['mainPanel']({
                model: _this.model,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            // console.log("Main Connections View", listService.dashboardLayout.mainPanelView);
            listService.dashboardLayout.mainPanelView.render();
            //PF-5994 until the dashboard was loaded change the flag to allow a new event
            listService.dashboardMenuClick = false;
        });

        const settingsFn = (() => {
            listService.dashboardLayout.mainPanelView = new views['mainPanel']({
                model: _this.model,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            // console.log("Main Settings View", listService.dashboardLayout.mainPanelView);
            listService.dashboardLayout.mainPanelView.render();
            //PF-5994 until the dashboard was loaded change the flag to allow a new event
            listService.dashboardMenuClick = false;
        });

        const defaultFn = (() => {
            listService.dashboardLayout.mainPanelView = new views['mainPanel']({
                model: _this.model,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            // console.log("Main Panel View", listService.dashboardLayout.mainPanelView);
            listService.dashboardLayout.mainPanelView.render();
            //PF-5994 until the dashboard was loaded change the flag to allow a new event
            listService.dashboardMenuClick = false;
        });

        const tabMap = {
            'forms': formsFn,
            'reports': reportFn,
            'notifications': notificationsFn,
            'connections': connectionsFn,
            'settings': settingsFn,
            'default': defaultFn
        }; 

        // Dispatch tabName to a panel rendering function, and execute it.
        tabMap[ tabMap[tabName] ? tabName : 'default' ]();

    }

    loadTab( tabName ) {
        listService.activeDashboardTab = tabName;
        listService.mainKind = '';
        listService.formItemSelected = undefined;
        listService.reportItemSelected = undefined;
        listService.connectionItemSelected = undefined;
        listService.userItemSelected = undefined;
        listService.actionItemSelected = undefined; 

        let setDefaultValue = function() {
            for (let property in this) {
                if (typeof this[property] !== 'function') {
                    this[property] = undefined;
                }                    
            }

            listService.userItemSelected = undefined;

            return this;
        };

        let setPropValue= function (property, value) {
            let newValue = value;
            let id = newValue.id !== undefined ? newValue.id : newValue.formId;
            if (newValue && isNaN(id) || id === '0') {
                newValue = undefined;
            }
            this[property] = newValue;                        

            return this;
        };

        let getPropValue = function(property) {
            return this[property];
        };
 
        listService.dashboardSettingsItems = (function() {                
                return {
                    userGroup: undefined, 
                    userPosition: undefined, 
                    userList: undefined, 
                    userEmail: undefined, 
                    setDefaultValue: setDefaultValue, 
                    setPropValue: setPropValue, 
                    getPropValue: getPropValue 
                }
        })();

        listService.dashboardFormsItems = (function() {                
            return {
                formItemSelected: undefined,
                formFolderSelected: undefined,
                instanceItemSelected: undefined,
                setDefaultValue: setDefaultValue, 
                setPropValue: setPropValue, 
                getPropValue: getPropValue 
            }
        })();

        const views = this.options.tabs.get( tabName );

        //If you don't silence this the listener to the model, change will trigger this method twice and break the rest service
        this.model.set('selectedTab', tabName, SILENT);

        // Maybe Stash this view in ListService so we can reference it from other views??
        if (listService.dashboardLayout.leftPanelView) {
            listService.dashboardLayout.leftPanelView.$el.empty().off();
            /* off to unbind the events */
            listService.dashboardLayout.leftPanelView.stopListening();
        }

        if (listService.dashboardLayout.mainPanelView) {
            listService.dashboardLayout.mainPanelView.$el.empty().off();
            /* off to unbind the events */
            listService.dashboardLayout.mainPanelView.stopListening();
        }

         $('li.dashboard-tab').removeClass('active');
         $(`li[name='${this.model.get('selectedTab')}']`).addClass('active');

        RestService.getAccountLicenseStatus().then( data => {
            listService.dashboardLayout.leftPanelView = new views['leftPanel']({model: this.model, el: constants.DASHBOARD_LEFT_PANEL});
            listService.dashboardLayout.leftPanelView.render();
            this._dispatchTabView(views, tabName); 
        }).catch((error) => {
            console.log(error || 'Unknown Error');
        });

        $('li.dashboard-tab').removeClass('active');
        $(`li[name='${this.model.get('selectedTab')}']`).addClass('active'); 

        const quickHelpView = new quickHelp({el:".quick-help-view", type: 'dash', helpLink: this.model.get('helpUrl')});
        quickHelpView.render();
    }

    _menuHelp() {
        Backbone.history.loadUrl('dbhelp');
    }

    _menuExit(ev) {
        ev.preventDefault();
        RestService.logout().then(response => {
            console.log('Logout Response', response);
            window.localStorage.clear();
            listService._activeDashboardTab = '';
            sessionStorage.setItem('timesGreetingWindowOpened', 0);
            util.navigateToLogin();
        }); 
    }

    render() {
        //PF-10276 Validate if is a trial account to show the Chat with Support widget
        this.model.set('isTrial', util.isTrue(RestService.getProfile().IsTrial), SILENT);
        
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        // adjust BODY css
        $('body').css({'overflow-y': 'auto', 'overflow-x': 'hidden'});
        $('html').css({'overflow': 'hidden'});

        this.$el.css('cursor', 'default');
     
        if(util.navigateToPage){
            const backTo = util.navigateToPage;
            switch (backTo[0]){
                case 'f':
                    this.loadTab('forms');
                break;
                case 'r':
                    this.loadTab('reports');
                break;
                case 'n':
                    this.loadTab('notifications');
                break;
                case 'c':
                    this.loadTab('connections');
                break;
                case 's':
                    this.loadTab('settings');
                break;
                default:
                    this.loadTab('forms');
                break;
            }
        }
        else{
            this.loadTab(this.model.get('selectedTab') || 'forms');
        }

        this.checkUpgrade();
        this.delegateEvents();

        // Making active selection for selected tab.
        return this;
    }

    // Method that refreshes the current active view by detecting the selected node on the tree and triggering the respective event depending the case on the different LeftPanelViews.
    refreshMainView(ev){
        ev.preventDefault();
        
        var selectedNode = $('.bg-success'),
        selectedNodeSectionType = selectedNode.attr('data-nodetype'),
        itemId = selectedNode.find('i').attr('data-itemid'),
        groupType = selectedNode.find('i').attr('data-groupType'),
        nodeType = selectedNode.find('i').attr('data-nodeType'),
        dataTarget = selectedNode.find('i').attr('data-target'),
        selectedSection = $('.document.dashboard.active'),
        selectedSectionItemId = selectedSection.find('div.document-heading').attr('data-itemid'),
        selectedSectionGroupType = selectedSection.find('div.document-heading').attr('data-grouptype'),
        selectedSectionNodeType = selectedSection.find('div.document-heading').attr('data-nodetype'),
        selectedSectionDataTarget = selectedSection.find('div.document-heading').attr('data-target');

        if((listService.activeDashboardTab === constants.DASHBOARD_SECTION_APPS) || (listService.activeDashboardTab === constants.DASHBOARD_SECTION_REPORTS)){
            //TO DO: Create a variable to track whether the user is entering or leaving the workspace view, to control if the table must be reloaded or not
            const table = $('.app-table');
            
            if (table.length > 0){
                if(listService.activeDashboardTab === constants.DASHBOARD_SECTION_APPS){        
                    eventBus.trigger('reloadTable');
                    return;
                }else if (listService.activeDashboardTab === constants.DASHBOARD_SECTION_REPORTS) {    
                    eventBus.trigger('reloadTableReport');
                    return;
                }
            }
    
            if (!listService.dashboardLayout.leftPanelView.detailView) { //IF it is not the apps overview page

                const refreshButton = $('#pf-refresh-main-view');
                const refreshItemId = refreshButton.attr('data-appid');
                if (refreshItemId !== -1) {

                    if (selectedSectionNodeType === "viewForms") {
                        groupType = constants.FORMS_VIEW_GROUP_TYPE;
                        nodeType = "viewableFormInstance";
                    }


                    if (!groupType) {
                        let groupTypeId;
                        groupType = groupTypeId;
                        if (listService.activeDashboardTab === constants.DASHBOARD_SECTION_APPS) {
                            groupTypeId = constants.FORMS_PRIVATE_GROUP_TYPE;
                        } else if (listService.activeDashboardTab === constants.DASHBOARD_SECTION_REPORTS) {
                            groupTypeId = constants.REPORTS_PRIVATE_GROUP_TYPE;
                        }
                    }

                    itemId = groupType + '_' + refreshItemId;
                    nodeType = nodeType || 'attn';
                    dataTarget = '#well' + itemId;

                }

            }
        }

        /**** Forms Section ****/

        // Private Forms Child Nodes Refresh
        if (selectedNodeSectionType === 'PrivateForms' && util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_PRIVATE_NODES,'1','#well_2','PrivateForms');
        }
        
        // Shared Forms Child Nodes Refresh
        else if (selectedNodeSectionType === 'SharedForms' && util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_PRIVATE_NODES,'2','#well_3','SharedForms');
        }
        
        // Form Folders Child Nodes Refresh
        else if(nodeType === 'group' &&
            (groupType === '1' || groupType === '2') &&
            util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_FOLDER,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Form Instances Child Nodes Refresh
        else if(nodeType === 'browseFormInstances' && util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_FORM_INSTANCES,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing edit forms details view and child nodes in case an instance was created externally.
        else if(nodeType === 'attn' && 
                this.model.get('selectedTab') === 'forms'){ 
            eventBus.trigger(constants.EV_REFRESH_FORM,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing View Form Child Nodes and Detail View
        else if(nodeType === 'viewableFormInstance' &&
                this.model.get('selectedTab') === 'forms'){

            const formName = $('.page-title li.active').text().split("-")[1].trim();
            eventBus.trigger(constants.EV_REFRESH_VIEW_FORM_AND_DETAIL,
                itemId,
                groupType,
                nodeType,
                dataTarget,
                formName)
        }

        // Refreshing View Forms Root Section
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('View Apps') &&
            util.isElementExpanded($('#well_4'))){
            eventBus.trigger(constants.EV_REFRESH_VIEW_FORMS,
                selectedSectionItemId,
                selectedSectionGroupType,
                selectedSectionNodeType,
                selectedSectionDataTarget);
        }

        //  Refreshing Library Forms Root Section
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Library') &&
            util.isElementExpanded($('#well_5'))){
            eventBus.trigger(constants.EV_REFRESH_LIBRARY_FORMS,
                selectedSectionItemId,
                '0',
                selectedSectionNodeType,
                selectedSectionDataTarget);
        }

        //  Refreshing Library Folders
        else if(nodeType === 'group' &&
            groupType === '0' &&
            util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_LIBRARY_FOLDER,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        /**** Reports Section ****/

        // Refreshing Private Reports Root Section
        else if (selectedNodeSectionType === 'PrivateReports' && util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_PRIVATE_REPORT_NODES,'3','#well_2','PrivateReports');
        }

        // Refreshing Shared Reports Root Section
        else if (selectedNodeSectionType === 'SharedReports' && util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_PRIVATE_REPORT_NODES,'4','#well_3','SharedReports');
        }

        // Refreshing Edit Reports Folders
        else if(nodeType === 'group' &&
            (groupType === '3' || groupType === '4') &&
            util.isElementExpanded(selectedNode.next('div'))){
            eventBus.trigger(constants.EV_REFRESH_EDIT_REPORT_FOLDER,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing View Reports Root Section
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('View Reports') &&
            util.isElementExpanded($('#well_4'))){
            eventBus.trigger(constants.EV_REFRESH_VIEW_REPORTS,
                selectedSectionItemId,
                selectedSectionGroupType,
                selectedSectionNodeType,
                selectedSectionDataTarget);
        }

        // Refreshing View Reports Folders
        else if((nodeType === 'viewReports' &&
                groupType === 'viewReports' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_VIEW_REPORT_FOLDER,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        /**** Notifications Section ****/

        // Refreshing Attention Needed Notification Nodes and Detail View
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Attention Needed') && util.isElementExpanded($('#well_1'))){
            eventBus.trigger(constants.EV_REFRESH_ATTENTION_NEEDED_NOTIFICATIONS_DASHBOARD_AND_NODES,'9','#well_1','attentionNeeded');
        }

        // Refreshing No Attention Needed Notification Nodes and Detail View
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('No Attention Needed') && util.isElementExpanded($('#well_2'))){
            eventBus.trigger(constants.EV_REFRESH_NO_ATTENTION_NEEDED_NOTIFICATIONS_DASHBOARD_AND_NODES,'9','#well_2','noAttentionNeeded');
        }

        // Refreshing Failed Notification Nodes and Detail View
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Failed Notifications') && util.isElementExpanded($('#well_3'))){
            eventBus.trigger(constants.EV_REFRESH_FAILED_NOTIFICATIONS_DASHBOARD,'9','#well_3','failedNotifications');
        }

        /**** Connections Section ****/

        // Refreshing Database Connections Nodes And Detail
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Databases') && util.isElementExpanded($('#well_1'))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_NODES,'1','#well_1','databases');
        }

        // Refreshing Directory Services Connections Nodes And Detail
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Directory Services') && util.isElementExpanded($('#well_2'))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_NODES,'2','#well_2','directory');
        }

        // Refreshing Web Services Connections Nodes And Detail
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Web Services') && util.isElementExpanded($('#well_3'))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_NODES,'3','#well_3','web');
        }

        // Refreshing Form Connections Nodes And Detail
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Apps') && util.isElementExpanded($('#well_4'))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_NODES,'4','#well_4','forms');
        }

        // Refreshing Google SpreadSheets Connections Nodes And Detail
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Google Sheets') && util.isElementExpanded($('#well_5'))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_NODES,'9','#well_5','google');
        }

        // Refreshing Text Connections Nodes And Detail
        else if(selectedNode.length === 0 &&
            selectedSection &&
            selectedSection.text().includes('Text File') && util.isElementExpanded($('#well_6'))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_NODES,'7','#well_6','text');
        }

        // Refreshing Database Action Detail View
        else if((nodeType === '1' &&
                groupType === 'databases' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_ACTIONS,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing Directory Action Detail View
        else if((nodeType === '2' &&
                groupType === 'directory' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_ACTIONS,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing Web Services Action Detail View
        else if((nodeType === '3' &&
                groupType === 'web' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_ACTIONS,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing Forms Action Detail View
        else if((nodeType=== '4' &&
                groupType === 'forms' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_ACTIONS,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing Google Spreadsheet Detail View
        else if((nodeType === '9' &&
                groupType === 'google' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_ACTIONS,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing Text Detail View
        else if((nodeType === '7' &&
                groupType === 'text' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_CONNECTION_ACTIONS,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        /**** Settings Section ****/

        // Refreshing users and detail view
        else if((nodeType === 'users' &&
                groupType === '70' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_USER_NODES_AND_DETAIL,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing user groups and detail view
        else if((nodeType === 'userGroup' &&
                groupType === '70' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_USER_GROUP_NODES_AND_DETAIL,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing positions and detail view
        else if((nodeType === 'positions' &&
                groupType === '70' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_POSITION_NODES_AND_DETAIL,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing lists
        else if((nodeType === 'listGroup' &&
                groupType === '71' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_LIST_NODES,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }

        // Refreshing emails
        else if((nodeType === 'emailGroup' &&
                groupType === '71' &&
                util.isElementExpanded(selectedNode.next('div')))){
            eventBus.trigger(constants.EV_REFRESH_EMAIL_SERVER_NODES,
                itemId,
                groupType,
                nodeType,
                dataTarget)
        }


        // Other cases will have its own refresh routine, which will be called from its own view.
        else {
            if (listService.dashboardLayout.leftPanelView.detailView && listService.dashboardLayout.leftPanelView.detailView.refresh) {
                listService.dashboardLayout.leftPanelView.detailView.render();
            }
            else if(listService.dashboardLayout.mainPanelView && listService.dashboardLayout.mainPanelView.refresh) {
                listService.dashboardLayout.mainPanelView.refresh();    
            }
            else if (listService.dashboardLayout.mainPanelView) {
                listService.dashboardLayout.mainPanelView.render();
            }
        }
    }
}

export default DashboardView;